import JobDialog from './JobDialog';
import { useGetJobQuery } from '../../api/jobs/GetJobQuery';
import JobDialogProps from './JobDialogProps';

interface EditJobDialogWrapperProps extends Omit<JobDialogProps, 'job'> {
  selectedId: string;
}

const EditJobDialogWrapper = ({
  selectedId,
  ...props
}: EditJobDialogWrapperProps) => {
  const selectedJob = useGetJobQuery(selectedId);
  return <JobDialog job={selectedJob} {...props} />;
};

export default EditJobDialogWrapper;
